import { api } from "./apiClient";
import { AgendaEntry } from "@/types/agenda";

export interface CitaItem {
  fecha: string;
  hora: string;
  userName: string;
  ownerID: string;
  actividad: string;
  empresa: string;
  ubicacion: string;
  clienteNombre: string;
  clienteNuevoRenovacion: string;
  comentarios: string;
  guardado?: boolean; // true si la cita tiene datos guardados en BD
}

export interface AsesorAgenda {
  ownerID: string;
  userName: string;
  name: string;
  puesto?: string;
  region?: string;
  userEstatus?: string;
  acl: string;
}

export interface CalendarioAgendasResponse {
  asesores: AsesorAgenda[];
  citas: {
    [ownerID: string]: {
      [fecha: string]: {
        [hora: string]: CitaItem;
      };
    };
  };
  diasAgenda: {
    [fecha: string]: string;
  };
  empresasPorAsesor: {
    [ownerID: string]: string[];
  };
}

export const agendasService = {
  getAll: (start?: string, end?: string) => {
    const params = new URLSearchParams();
    if (start) params.set("start", start);
    if (end) params.set("end", end);
    const suffix = params.toString() ? `?${params.toString()}` : "";
    return api.get<AgendaEntry[]>(`/agendas/${suffix}`);
  },
  create: (payload: AgendaEntry) => api.post<AgendaEntry>("/agendas/", payload),
  
  getCalendario: (ownerId: string, fechaInicio: string, fechaFin: string) => {
    const params = new URLSearchParams();
    params.set("owner_id", ownerId);
    params.set("fecha_inicio", fechaInicio);
    params.set("fecha_fin", fechaFin);
    return api.get<CalendarioAgendasResponse>(`/agendas/calendario?${params.toString()}`);
  },
  
  guardar: (payload: AgendaEntry) => api.post<AgendaEntry>("/agendas/guardar", payload),
};
